import { useCtaHref } from '@/components/astro/cta-button/cta-button.tsx';
import { getDefaultCtaLabel } from '@/components/astro/cta-button/cta-label';
import { FAQ } from '@/components/astro/new-design-25/ui/FAQ';
import { useFreePlan } from '@/hooks/use-free-plan-availability';
import '@/styles/astro/new-design.css';
import { Button } from '@listening/frontend/components/radix/button';
import * as m from '@/paraglide/messages';

type FAQItem = {
  question: string;
  answer: string;
};

function getBaseFaqs(): Array<FAQItem> {
  return [
    {
      question: m.faq_question_pronunciation(),
      answer: m.faq_answer_pronunciation(),
    },
    {
      question: m.faq_question_sections(),
      answer: m.faq_answer_sections(),
    },
    {
      question: m.faq_question_citations(),
      answer: m.faq_answer_citations(),
    },
  ];
}

// const freePlanFaq: FAQItem = {
//   question: 'What happens if I cancel during the 3 days trial?',
//   answer: "You won't get billed at all!",
// };

function getFaqs(_isInFreePlanCountry: boolean): Array<FAQItem> {
  // Free plan FAQ disabled for now
  // if (isInFreePlanCountry) {
  //   const faqs = getBaseFaqs();
  //   return [faqs[0]!, freePlanFaq, ...faqs.slice(1)];
  // }
  return getBaseFaqs();
}

export function FAQButton() {
  const { isInFreePlanCountry } = useFreePlan();
  const faqs = getFaqs(isInFreePlanCountry);
  const ctaHref = useCtaHref();
  const ctaLabel = getDefaultCtaLabel(isInFreePlanCountry);
  return (
    <FAQ description={m.faq_description()} faqs={faqs} showApplyButton={false}>
      <div
        aria-label={m.faq_get_started_label()}
        className='xs:justify-center mx-auto mt-12 flex w-full max-w-[800px] flex-col items-center gap-4 lg:flex-row'
        role='complementary'
      >
        <div className='gradient-border xs:w-auto relative w-full'>
          <Button
            asChild
            className='xs:w-auto relative w-full bg-transparent px-6 py-4 text-center text-base font-medium text-black transition-all duration-300 hover:bg-transparent hover:shadow-lg sm:px-24 sm:py-8 sm:text-lg'
          >
            <a href={ctaHref} rel='noopener noreferrer' target='_blank'>
              {ctaLabel}
            </a>
          </Button>
        </div>
      </div>
    </FAQ>
  );
}
